/**
 * RefundSummary - lokaler Ersatz
 *
 * Der frühere `RefundSummary`-Export aus `@tasty/shared` existiert nicht mehr.
 * Bis das Refund-Feature fachlich neu spezifiziert ist, zeigt diese minimale
 * Komponente einen Leerzustand. `cases` ist bewusst breit typisiert.
 */

export interface RefundCase {
  id?: string;
  [key: string]: unknown;
}

interface RefundSummaryProps {
  cases: RefundCase[];
}

export function RefundSummary({ cases }: RefundSummaryProps) {
  if (!cases || cases.length === 0) {
    return (
      <div className="rounded-lg border border-dashed p-8 text-center text-sm text-muted-foreground">
        Keine Rückerstattungen vorhanden.
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {cases.map((c, i) => (
        <div key={c.id ?? i} className="rounded-lg border p-4 text-sm">
          {c.id ?? `Fall ${i + 1}`}
        </div>
      ))}
    </div>
  );
}

export default RefundSummary;
